module.exports = __webpack_public_path__ + "img/bicycle-back.366ef65c.jpg";